import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { getBrowserReference, getDeviceType } from '@app/shared/utils';
import { IDomain, TokenService, User } from 'viggo-sistemas-core-web';
import {
  EventAnalyticsGoogle,
  IContentEventApi
} from './analytics_event.model';

/**
 * By declaring var gtag we are letting Angular know that somewhere in the application there is a method that we want to // access called gtag. This enables us to then create a new method off of gtag which we imported into our index.html file earlier.
 */
declare var gtag: any;

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  constructor(
    protected tokenService: TokenService,
    protected datePipe: DatePipe
  ) {}

  /**
   * The new method we created is called trackEvent() I have left comments to help you understand what each property will show in the dashboard once you are done.
   * @param event - Descreve o que é o evento. Com essa informação para cada página, elemento ou componente podemos
   * especificar detalhes sobre o evento
   */
  trackEvent(event: EventAnalyticsGoogle) {
    gtag('event', event.name, event.value);
  }

  /**
   * Envia o evento no GTAG do Google Analytics identificando
   * algum comportamento realizado pelo usuário envolvendo API
   */
  trackEventUseApi(event_name: string, value: IContentEventApi) {
    if (event_name === 'ACESSO_SISTEMA')
      localStorage.setItem('ENVIOU_EVENTO_LOGIN', 'true');
    const domain = this.tokenService.getDomain() as IDomain;
    const user = this.tokenService.getUser() as User;
    this.trackEvent({
      value: {
        usuario: user.name + ' - ' + user.id,
        dominio: domain.name + ' - ' + domain.id,
        navegador: getBrowserReference(),
        dispositivo: getDeviceType(),
        deslogado_em: 'CONTEÚDO VAZIO',
        resposta_api: 'CONTEÚDO VAZIO',
        rota: 'CONTEÚDO VAZIO',
        acessado_em: 'CONTEÚDO VAZIO',
        conteudo: 'CONTEÚDO VAZIO',
        origem: 'CONTEÚDO VAZIO',
        executado_em: this.datePipe.transform(new Date()),
        ...value
      } as IContentEventApi,
      name: event_name
    });
  }
}
